export interface Article {
  id: string;
  title: string;
  subtitle?: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  subcategory?: string;
  author: string;
  authorSlug: string;
  authorRole?: string;
  authorBio?: string;
  authorImage?: string;
  imageUrl: string;
  imageAlt?: string;
  gallery?: string[];
  publishedAt: string;
  updatedAt?: string;
  readTime: string;
  views: number;
  tags: string[];
  status: "draft" | "pending_review" | "published" | "scheduled" | "archived";
  isFeatured?: boolean;
  isBreaking?: boolean;
  isTopNews?: boolean;
  isOpinion?: boolean;
  isColumn?: boolean;
  showOnHomepageSlider?: boolean;
  showInTopNewsColumn?: boolean;
  showInCategoryFeatured?: boolean;
  commentsEnabled?: boolean;
  adsEnabled?: boolean;
  sources?: { title: string; url: string }[];
  internalLinks?: { title: string; slug: string }[];
  externalLinks?: { title: string; url: string }[];
  relatedArticleIds?: string[];
  // SEO fields
  metaTitle?: string;
  metaDescription?: string;
  focusKeyword?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  twitterImage?: string;
  noIndex?: boolean;
}

export interface SocialLink {
  platform: string;
  url: string;
}

export type AuthorType = "redaktion" | "autor" | "kolumnist" | "gastautor" | "editor";

export interface Author {
  name: string;
  slug: string;
  role: string;
  shortBio: string;
  longBio: string;
  email: string;
  image: string;
  articleCount: number;
  author_type: AuthorType;
  isActive: boolean;
  socialLinks: SocialLink[];
}

export const authors: Author[] = [
  {
    name: "Markus Weber",
    slug: "markus-weber",
    role: "Chefredakteur",
    shortBio: "Chefredakteur des Helvetik Journal. Seit 15 Jahren berichtet er über Schweizer Politik und Wirtschaft.",
    longBio: "Markus Weber ist Chefredakteur des Helvetik Journal. Seit 15 Jahren berichtet er über Schweizer Politik und Wirtschaft. Zuvor war er bei der NZZ und dem Tages-Anzeiger tätig. Er studierte Politikwissenschaft an der Universität Zürich und absolvierte ein Master-Studium an der London School of Economics. Weber ist bekannt für seine präzisen Analysen der Schweizer Politik und seine exklusiven Interviews mit Bundesräten. Er lebt mit seiner Familie in Bern und ist Vater von zwei Kindern.",
    email: "markus.weber@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20male%20journalist%20portrait%20middle%20aged%20man%20wearing%20dark%20blazer%20white%20shirt%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=101&orientation=squarish",
    articleCount: 142,
    author_type: "redaktion",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/markusweber_hj" },
      { platform: "linkedin", url: "https://linkedin.com/in/markusweber" },
    ],
  },
  {
    name: "Dr. Anna Fischer",
    slug: "anna-fischer",
    role: "Gesundheits-Redakteurin",
    shortBio: "Promovierte Medizinerin und leitende Gesundheits-Redakteurin mit journalistischer Expertise.",
    longBio: "Dr. Anna Fischer ist promovierte Medizinerin und leitende Gesundheits-Redakteurin. Sie verbindet medizinisches Fachwissen mit journalistischer Expertise. Nach ihrem Medizinstudium an der Universität Basel und der Promotion in Public Health an der Johns Hopkins University arbeitete sie zunächst als Ärztin im Universitätsspital Zürich, bevor sie 2018 zum Journalismus wechselte. Fischer ist bekannt für ihre fundierten Analysen des Schweizer Gesundheitssystems und ihre kritische Berichterstattung über die Pharma-Industrie.",
    email: "anna.fischer@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20journalist%20portrait%20woman%20in%20her%2040s%20wearing%20elegant%20blouse%20confident%20warm%20smile%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=102&orientation=squarish",
    articleCount: 89,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/drannafischer" },
      { platform: "linkedin", url: "https://linkedin.com/in/annafischer" },
    ],
  },
  {
    name: "Thomas Keller",
    slug: "thomas-keller",
    role: "Finanz-Experte",
    shortBio: "Ehemaliger Banker und unabhängiger Finanzjournalist mit insider-Wissen.",
    longBio: "Thomas Keller ist ehemaliger Banker und heute unabhängiger Finanzjournalist. Er analysiert die Schweizer Finanzwelt mit insider-Wissen und kritischem Blick. Nach 20 Jahren bei der UBS und Credit Suisse wechselte Keller 2015 in den Journalismus. Er ist spezialisiert auf Banken, Börsen und Kryptowährungen. Seine wöchentliche Kolumne \"Kellers Kontext\" ist eine der meistgelesenen Finanz-Kolumnen der Schweiz. Keller lebt in Zürich und ist passionierter Bergwanderer.",
    email: "thomas.keller@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20male%20finance%20expert%20portrait%20man%20in%20his%2050s%20wearing%20suit%20and%20tie%20serious%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=103&orientation=squarish",
    articleCount: 156,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/thomaskeller_fin" },
      { platform: "linkedin", url: "https://linkedin.com/in/thomaskeller" },
    ],
  },
  {
    name: "Sarah Müller",
    slug: "sarah-mueller",
    role: "Tech-Redakteurin",
    shortBio: "Berichtet über Technologie und KI. Studierte Informatik an der ETH Zürich.",
    longBio: "Sarah Müller berichtet über Technologie und KI aus der Schweiz. Sie studierte Informatik an der ETH Zürich und schreibt für führende Tech-Publikationen. Nach ihrem Master-Abschluss in Machine Learning arbeitete sie drei Jahre bei Google Zürich, bevor sie 2020 zum Journalismus wechselte. Müller ist bekannt für ihre klaren Erklärungen komplexer Technologien und ihre kritische Berichterstattung über Datenschutz und KI-Ethik. Sie lebt in Zürich und engagiert sich für mehr Frauen in der Tech-Branche.",
    email: "sarah.mueller@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20journalist%20portrait%20woman%20in%20her%2030s%20wearing%20modern%20casual%20outfit%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=104&orientation=squarish",
    articleCount: 78,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/sarahmueller_tech" },
      { platform: "linkedin", url: "https://linkedin.com/in/sarahmueller" },
      { platform: "github", url: "https://github.com/sarahmueller" },
    ],
  },
  {
    name: "Peter Schmid",
    slug: "peter-schmid",
    role: "Politik-Analyst",
    shortBio: "Einer der erfahrensten Politik-Journalisten der Schweiz. Beobachtet Bern seit drei Jahrzehnten.",
    longBio: "Peter Schmid ist einer der erfahrensten Politik-Journalisten der Schweiz. Seit drei Jahrzehnten beobachtet er die Machtverhältnisse in Bern. Er begann seine Karriere beim Bundner Tagblatt und war später Korrespondent in Bern für mehrere Schweizer Zeitungen. Schmid ist bekannt für seine exklusiven Enthüllungen und seine tiefen Einblicke in die Bundesratswahl-Prozesse. Er hat mehrere Bücher über die Schweizer Politik geschrieben und ist regelmässiger Gast in politischen Talkshows.",
    email: "peter.schmid@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20male%20political%20analyst%20portrait%20senior%20man%20in%20his%2060s%20wearing%20glasses%20and%20blazer%20thoughtful%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=105&orientation=squarish",
    articleCount: 203,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/peterschmid_pol" },
      { platform: "linkedin", url: "https://linkedin.com/in/peterschmid" },
    ],
  },
  {
    name: "Lisa Huber",
    slug: "lisa-huber",
    role: "Redakteurin",
    shortBio: "Deckt Technologie- und Innovationsgeschichten auf. Spezialisiert auf Startups.",
    longBio: "Lisa Huber deckt Technologie- und Innovationsgeschichten auf. Sie ist spezialisiert auf Schweizer Startups und digitale Transformation. Nach ihrem Studium der Kommunikationswissenschaft an der Universität Zürich arbeitete sie bei verschiedenen Tech-Blogs, bevor sie 2019 zum Helvetik Journal kam. Huber ist bekannt für ihre exklusiven Startup-Portraits und ihre Berichterstattung über die Schweizer Tech-Szene. Sie organisiert jährlich das \"Helvetik Tech Summit\" und ist Mentorin für junge Journalistinnen.",
    email: "lisa.huber@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20reporter%20portrait%20woman%20in%20her%2030s%20wearing%20smart%20casual%20friendly%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=108&orientation=squarish",
    articleCount: 67,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/lisahuber_tech" },
      { platform: "linkedin", url: "https://linkedin.com/in/lisahuber" },
    ],
  },
  {
    name: "Ruth Steiner",
    slug: "ruth-steiner",
    role: "Rechts-Expertin",
    shortBio: "Promovierte Juristin. Berichtet über Rechtsprechung und Verfassungsfragen.",
    longBio: "Ruth Steiner ist promovierte Juristin und berichtet über Rechtsprechung, Verfassungsfragen und den Bundesgerichtshof. Nach ihrem Studium der Rechtswissenschaft an der Universität Zürich und der Promotion in Verfassungsrecht arbeitete sie als Rechtsanwältin bei einer Grosskanzlei in Genf, bevor sie 2017 in den Journalismus wechselte. Steiner ist bekannt für ihre präzisen Analysen von Bundesgerichts-Entscheiden und ihre kritische Begleitung der Gesetzgebungsprozesse. Sie lebt in Zürich und ist passionierte Skifahrerin.",
    email: "ruth.steiner@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20female%20lawyer%20portrait%20woman%20in%20her%2050s%20wearing%20elegant%20dark%20suit%20composed%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=109&orientation=squarish",
    articleCount: 112,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/ruthsteiner_recht" },
      { platform: "linkedin", url: "https://linkedin.com/in/ruthsteiner" },
    ],
  },
  {
    name: "Hans Meier",
    slug: "hans-meier",
    role: "Wirtschafts-Redakteur",
    shortBio: "Berichtet über Märkte, Währungen und die Schweizer Wirtschaft. Präzise Marktanalysen.",
    longBio: "Hans Meier berichtet über Märkte, Währungen und die Schweizer Wirtschaft. Er ist bekannt für seine präzisen Marktanalysen. Nach seinem Studium der Volkswirtschaftslehre an der Universität Bern arbeitete er als Analyst bei einer Grossbank, bevor er 2012 in den Journalismus wechselte. Meier ist spezialisiert auf Devisenmärkte, Rohstoffe und die Schweizer Exportwirtschaft. Seine täglichen Markt-Updates sind bei Investoren und Händlern sehr beliebt. Er lebt in Bern und ist passionierter Golfer.",
    email: "hans.meier@helvetik.ch",
    image: "https://readdy.ai/api/search-image?query=Professional%20male%20business%20editor%20portrait%20man%20in%20his%2050s%20wearing%20dark%20sweater%20serious%20professional%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=110&orientation=squarish",
    articleCount: 134,
    author_type: "autor",
    isActive: true,
    socialLinks: [
      { platform: "twitter", url: "https://twitter.com/hansmeier_wirt" },
      { platform: "linkedin", url: "https://linkedin.com/in/hansmeier" },
    ],
  },
];

export const articles: Article[] = [
  {
    id: "1",
    title: "Bundesrat beschließt neue Klimaschutz-Massnahmen für 2026",
    subtitle: "CO2-Abgabe steigt auf 120 Franken pro Tonne – Industrie muss erneuerbare Energien nutzen",
    slug: "bundesrat-klimaschutz-massnahmen-2026",
    excerpt: "Der Schweizer Bundesrat hat am Mittwoch ein umfassendes Klimaschutz-Paket verabschiedet, das die CO2-Emissionen bis 2030 um 50 Prozent reduzieren soll.",
    content: "Der Schweizer Bundesrat hat am Mittwoch ein umfassendes Klimaschutz-Paket verabschiedet, das die CO2-Emissionen bis 2030 um 50 Prozent reduzieren soll. Die neuen Massnahmen umfassen eine Erhöhung der CO2-Abgabe auf 120 Franken pro Tonne sowie verbindliche Quoten für erneuerbare Energien in der Industrie.\n\nUmweltministerin Albert Rösti betonte, dass die Schweiz damit ihre Pariser Klimaziele erreichen könne. \"Wir haben keine Zeit zu verlieren\", sagte Rösti bei der Pressekonferenz in Bern. \"Die Schweiz muss Vorreiterin im Klimaschutz bleiben.\"\n\nKritiker aus der Wirtschaft warnen jedoch vor Wettbewerbsnachteilen. Der Schweizerische Gewerbeverband (SGV) forderte eine schrittweise Umsetzung, um Unternehmen nicht zu überfordern. \"Die Massnahmen müssen sozialverträglich und wirtschaftlich tragbar sein\", erklärte SGV-Direktor Hans-Ulrich Bigler.\n\nDie geplanten Massnahmen umfassen zudem eine Ausweitung des Emissionshandels auf weitere Sektoren, verstärkte Förderung von Elektromobilität und eine neue Gebäudesanierungs-Offensive. Die Kosten für die Umsetzung werden auf rund 8 Milliarden Franken geschätzt.\n\nDie Umweltorganisationen begrüssen den Entscheid, fordern aber noch ambitioniertere Ziele. Greenpeace Schweiz spricht von einem \"wichtigen, aber unzureichenden Schritt\". Die Abstimmung im Parlament ist für den Herbst geplant.",
    category: "Politik",
    categorySlug: "politik",
    subcategory: "Umweltpolitik",
    author: "Markus Weber",
    authorSlug: "markus-weber",
    authorRole: "Chefredakteur",
    authorBio: "Markus Weber ist Chefredakteur des Helvetik Journal. Seit 15 Jahren berichtet er über Schweizer Politik und Wirtschaft.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20journalist%20portrait%20middle%20aged%20man%20wearing%20dark%20blazer%20white%20shirt%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=101&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20Federal%20Council%20meeting%20room%20with%20politicians%20discussing%20climate%20policy%20documents%20on%20wooden%20table%20modern%20government%20building%20Bern%20Switzerland%20professional%20photography%20warm%20lighting%20dramatic%20composition&width=1200&height=675&seq=1&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Swiss%20Alps%20mountain%20landscape%20with%20green%20meadows%20and%20snow%20peaks%20dramatic%20sky%20professional%20nature%20photography%20wide%20angle&width=1200&height=675&seq=101&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Wind%20turbines%20in%20Swiss%20countryside%20renewable%20energy%20landscape%20professional%20photography%20dramatic%20sky%20wide%20angle&width=1200&height=675&seq=102&orientation=landscape",
    ],
    publishedAt: "2026-04-27T08:30:00Z",
    updatedAt: "2026-04-27T14:00:00Z",
    readTime: "5 Min.",
    views: 12450,
    tags: ["Klima", "Bundesrat", "Umwelt", "CO2"],
    status: "published",
    isFeatured: true,
    isBreaking: true,
    isTopNews: true,
    showOnHomepageSlider: true,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Bundesamt für Umwelt", url: "https://www.bafu.admin.ch" },
      { title: "Pariser Klimaabkommen", url: "https://unfccc.int" },
    ],
    internalLinks: [
      { title: "Die Schweiz und das Klima: Ein Überblick", slug: "schweiz-klima-ueberblick" },
      { title: "Energiestrategie 2050", slug: "energiestrategie-2050" },
    ],
    externalLinks: [
      { title: "Greenpeace Schweiz", url: "https://www.greenpeace.ch" },
      { title: "SGV Schweiz", url: "https://www.sgv-usam.ch" },
    ],
  },
  {
    id: "2",
    title: "Swisscom und Sunrise fusionieren: Was das für die Telekom-Branche bedeutet",
    subtitle: "15-Milliarden-Deal könnte Monopol-Bildung auslösen – Wettbewerbskommission prüft",
    slug: "swisscom-sunrise-fusion-telekom",
    excerpt: "Die angekündigte Fusion der beiden grössten Schweizer Telekom-Anbieter könnte den Markt grundlegend verändern. Experten warnen vor Monopol-Bildung.",
    content: "Die angekündigte Fusion der beiden grössten Schweizer Telekom-Anbieter könnte den Markt grundlegend verändern. Experten warnen vor Monopol-Bildung. Die Wettbewerbskommission prüft bereits den Deal, der einen Gesamtwert von über 15 Milliarden Franken haben soll.\n\nDie Fusion würde einen Telekom-Riesen mit über 10 Millionen Kunden schaffen. Kritiker befürchten höhere Preise und weniger Innovation. Befürworter argumentieren mit besserer Netzabdeckung und Investitionen in 5G.\n\n\"Dieser Deal verändert die gesamte Telekom-Landschaft der Schweiz\", sagt Telekom-Experte Dr. Martin Hirt. \"Die Frage ist, ob die Wettbewerbskommission zustimmt.\"\n\nDie Wettbewerbskommission (Weko) hat bereits eine vertiefte Prüfung eingeleitet. Ein Entscheid wird für Herbst 2026 erwartet. Die Fusion könnte bis zu 2.000 Stellen kosten.",
    category: "Technologie",
    categorySlug: "technologie",
    subcategory: "Telekommunikation",
    author: "Sarah Müller",
    authorSlug: "sarah-mueller",
    authorRole: "Tech-Redakteurin",
    authorBio: "Sarah Müller berichtet über Technologie und KI aus der Schweiz. Sie studierte Informatik an der ETH Zürich.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20journalist%20portrait%20woman%20in%20her%2030s%20wearing%20modern%20casual%20outfit%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=104&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20Swiss%20telecommunications%20tower%20with%205G%20antennas%20against%20Alpine%20mountain%20backdrop%20blue%20sky%20technology%20infrastructure%20professional%20photography%20dramatic%20wide%20angle&width=1200&height=675&seq=2&orientation=landscape",
    publishedAt: "2026-04-26T14:15:00Z",
    updatedAt: "2026-04-26T16:00:00Z",
    readTime: "4 Min.",
    views: 8930,
    tags: ["Telekom", "Fusion", "5G", "Swisscom"],
    status: "published",
    isFeatured: true,
    isBreaking: false,
    isTopNews: true,
    showOnHomepageSlider: true,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Wettbewerbskommission", url: "https://www.weko.admin.ch" },
    ],
    internalLinks: [
      { title: "5G in der Schweiz: Status Quo", slug: "5g-schweiz-status" },
    ],
    externalLinks: [
      { title: "Swisscom", url: "https://www.swisscom.ch" },
      { title: "Sunrise", url: "https://www.sunrise.ch" },
    ],
  },
  {
    id: "3",
    title: "Krankenkassen-Prämien 2027: Erste Schätzungen zeigen moderate Erhöhung",
    subtitle: "Helsana und CSS kommunizieren erste Zahlen – Experten empfehlen Prämienvergleich",
    slug: "krankenkassen-praemien-2027-schaetzung",
    excerpt: "Die ersten Berechnungen für die Krankenkassen-Prämien im Jahr 2027 deuten auf eine Erhöhung von durchschnittlich 3,5 Prozent hin.",
    content: "Die ersten Berechnungen für die Krankenkassen-Prämien im Jahr 2027 deuten auf eine Erhöhung von durchschnittlich 3,5 Prozent hin. Die Helsana und die CSS haben bereits erste Zahlen kommuniziert.\n\nExperten empfehlen den Prämienvergleich im Herbst. Die moderate Erhöhung ist auf steigende Gesundheitskosten und neue Medikamente zurückzuführen. Die Regierung prüft mögliche Entlastungsmassnahmen.\n\n\"Die Prämienentwicklung bleibt ein Dauerthema\", sagt Gesundheitsökonom Dr. Peter Zweifel. \"Die Kosten im Gesundheitswesen steigen schneller als das BIP.\"\n\nDie Prämien für Erwachsene könnten je nach Kanton um 2 bis 6 Prozent steigen. Familien mit Kindern sind besonders betroffen. Die Prämienverbilligung wird angepasst.",
    category: "Versicherung & Gesundheit",
    categorySlug: "versicherung-gesundheit",
    subcategory: "Krankenkasse",
    author: "Dr. Anna Fischer",
    authorSlug: "anna-fischer",
    authorRole: "Gesundheits-Redakteurin",
    authorBio: "Dr. Anna Fischer ist promovierte Medizinerin und leitende Gesundheits-Redakteurin.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20journalist%20portrait%20woman%20in%20her%2040s%20wearing%20elegant%20blouse%20confident%20warm%20smile%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=102&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20health%20insurance%20concept%20medical%20cross%20symbol%20clean%20minimalist%20white%20background%20professional%20healthcare%20photography%20soft%20lighting%20elegant%20composition&width=1200&height=675&seq=3&orientation=landscape",
    publishedAt: "2026-04-26T10:00:00Z",
    updatedAt: "2026-04-26T12:00:00Z",
    readTime: "6 Min.",
    views: 15670,
    tags: ["Krankenkasse", "Prämien", "Gesundheit", "Helsana"],
    status: "published",
    isFeatured: true,
    isBreaking: false,
    isTopNews: true,
    showOnHomepageSlider: false,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "BAG Prämienrechner", url: "https://www.priminfo.admin.ch" },
    ],
    internalLinks: [
      { title: "Krankenkassenwechsel: So geht's", slug: "krankenkassenwechsel-guide" },
    ],
    externalLinks: [
      { title: "Helsana", url: "https://www.helsana.ch" },
      { title: "CSS", url: "https://www.css.ch" },
    ],
  },
  {
    id: "4",
    title: "Credit Suisse-Nachfolge: UBS meldet Rekordgewinn im ersten Quartal",
    subtitle: "3,2 Milliarden Dollar Nettogewinn – höchster Quartalsgewinn seit Credit-Suisse-Übernahme",
    slug: "ubs-rekordgewinn-q1-2026",
    excerpt: "Die UBS hat im ersten Quartal 2026 einen Nettogewinn von 3,2 Milliarden Dollar verzeichnet – der höchste Quartalsgewinn seit der Übernahme der Credit Suisse.",
    content: "Die UBS hat im ersten Quartal 2026 einen Nettogewinn von 3,2 Milliarden Dollar verzeichnet – der höchste Quartalsgewinn seit der Übernahme der Credit Suisse. CEO Sergio Ermotti spricht von einer erfolgreichen Integration.\n\nDie Aktie stieg um 4 Prozent. Analysten hatten mit 2,8 Milliarden Dollar gerechnet. Die Wealth Management Division trug den grössten Teil zum Erfolg bei.\n\n\"Die Integration der Credit Suisse läuft besser als erwartet\", sagte Ermotti bei der Bilanzpressekonferenz. \"Wir sind auf Kurs, die Synergien zu realisieren.\"\n\nDie UBS hat bereits 12.000 Stellen im Rahmen der Integration abgebaut. Weitere 3.000 Stellen sollen bis Ende 2026 folgen. Die Kosten für die Integration belaufen sich auf 4 Milliarden Dollar.",
    category: "Finanzen",
    categorySlug: "finanzen",
    subcategory: "Banken",
    author: "Thomas Keller",
    authorSlug: "thomas-keller",
    authorRole: "Finanz-Experte",
    authorBio: "Thomas Keller ist ehemaliger Banker und heute unabhängiger Finanzjournalist.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20finance%20expert%20portrait%20man%20in%20his%2050s%20wearing%20suit%20and%20tie%20serious%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=103&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=UBS%20bank%20headquarters%20Zurich%20Switzerland%20modern%20glass%20building%20financial%20district%20professional%20architecture%20photography%20golden%20hour%20lighting%20dramatic%20sky&width=1200&height=675&seq=4&orientation=landscape",
    publishedAt: "2026-04-25T16:45:00Z",
    updatedAt: "2026-04-25T18:00:00Z",
    readTime: "4 Min.",
    views: 11200,
    tags: ["UBS", "Banken", "Börse", "Credit Suisse"],
    status: "published",
    isFeatured: true,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: true,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "UBS Quartalsbericht Q1 2026", url: "https://www.ubs.com" },
    ],
    internalLinks: [
      { title: "Die Credit-Suisse-Übernahme im Rückblick", slug: "credit-suisse-uebernahme" },
    ],
    externalLinks: [
      { title: "SIX Swiss Exchange", url: "https://www.six-group.com" },
    ],
  },
  {
    id: "5",
    title: "Google eröffnet neues KI-Forschungszentrum in Zürich",
    subtitle: "500 Millionen Franken Investition – 300 neue Stellen bis 2028",
    slug: "google-ki-forschungszentrum-zuerich",
    excerpt: "Der Tech-Riese investiert 500 Millionen Franken in ein neues Forschungszentrum für künstliche Intelligenz am Zürcher Standort.",
    content: "Der Tech-Riese investiert 500 Millionen Franken in ein neues Forschungszentrum für künstliche Intelligenz am Zürcher Standort. Bis 2028 sollen 300 neue Stellen entstehen.\n\nDer Fokus liegt auf multimodaler KI und maschinellem Lernen. Google Zürich ist bereits einer der grössten Entwicklungsstandorte ausserhalb der USA.\n\n\"Zürich ist ein wichtiger Standort für unsere KI-Forschung\", sagte Google-CEO Sundar Pichai bei der Ankündigung. \"Die Schweiz bietet exzellente Talente und eine starke Forschungslandschaft.\"\n\nDas neue Zentrum wird in der Google-Niederlassung am Europaallee-Quartier eingerichtet. Die ETH Zürich und die Universität Zürich sind als Forschungspartner involviert.",
    category: "Digital & KI",
    categorySlug: "digital-ki",
    subcategory: "Künstliche Intelligenz",
    author: "Lisa Huber",
    authorSlug: "lisa-huber",
    role: "Redakteurin",
    authorBio: "Lisa Huber deckt Technologie- und Innovationsgeschichten auf.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20reporter%20portrait%20woman%20in%20her%2030s%20wearing%20smart%20casual%20friendly%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=108&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20Google%20office%20building%20Zurich%20Switzerland%20contemporary%20architecture%20glass%20facade%20tech%20campus%20professional%20photography%20daylight%20wide%20angle&width=1200&height=675&seq=5&orientation=landscape",
    publishedAt: "2026-04-25T09:20:00Z",
    updatedAt: "2026-04-25T11:00:00Z",
    readTime: "5 Min.",
    views: 9870,
    tags: ["Google", "KI", "Zürich", "ETH"],
    status: "published",
    isFeatured: true,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: true,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Google AI Blog", url: "https://ai.googleblog.com" },
    ],
    internalLinks: [
      { title: "KI in der Schweiz: Der Überblick", slug: "ki-schweiz-ueberblick" },
    ],
    externalLinks: [
      { title: "Google Schweiz", url: "https://www.google.ch" },
      { title: "ETH Zürich AI Center", url: "https://ai.ethz.ch" },
    ],
  },
  {
    id: "6",
    title: "Nationalrat debattiert über Rentenreform 2030",
    subtitle: "AHV-Altersgrenze soll auf 67 Jahre steigen – Gewerkschaften protestieren",
    slug: "nationalrat-rentenreform-2030",
    excerpt: "Die geplante Rentenreform sorgt für hitzige Debatten im Nationalrat. Die AHV-Altersgrenze soll schrittweise auf 67 Jahre angehoben werden.",
    content: "Die geplante Rentenreform sorgt für hitzige Debatten im Nationalrat. Die AHV-Altersgrenze soll schrittweise auf 67 Jahre angehoben werden.\n\nGewerkschaften protestieren, während Wirtschaftsverbände die Reform begrüssen. Die Abstimmung ist für Herbst 2026 geplant.\n\n\"Diese Reform ist notwendig, um die AHV langfristig zu sichern\", sagt Wirtschaftsminister Guy Parmelin. \"Wir können nicht länger die Augen vor der demografischen Realität verschliessen.\"\n\nDie Gewerkschaft Unia spricht von einer \"Angriff auf die Arbeitnehmer\". Sie plant eine Referendums-Kampagne. Die SP hat bereits angekündigt, das Referendum zu ergreifen.",
    category: "Politik",
    categorySlug: "politik",
    subcategory: "Sozialpolitik",
    author: "Peter Schmid",
    authorSlug: "peter-schmid",
    authorRole: "Politik-Analyst",
    authorBio: "Peter Schmid ist einer der erfahrensten Politik-Journalisten der Schweiz.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20political%20analyst%20portrait%20senior%20man%20in%20his%2060s%20wearing%20glasses%20and%20blazer%20thoughtful%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=105&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20National%20Council%20parliament%20session%20Bern%20politicians%20debating%20grand%20assembly%20hall%20red%20seats%20professional%20photography%20documentary%20style%20dramatic%20lighting&width=1200&height=675&seq=6&orientation=landscape",
    publishedAt: "2026-04-24T11:30:00Z",
    updatedAt: "2026-04-24T13:00:00Z",
    readTime: "7 Min.",
    views: 13400,
    tags: ["AHV", "Rente", "Nationalrat", "Reform"],
    status: "published",
    isFeatured: false,
    isBreaking: true,
    isTopNews: true,
    showOnHomepageSlider: false,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "AHV21", url: "https://www.ahv21.ch" },
    ],
    internalLinks: [
      { title: "Die AHV-Reform erklärt", slug: "ahv-reform-erklaert" },
    ],
    externalLinks: [
      { title: "Unia Gewerkschaft", url: "https://www.unia.ch" },
    ],
  },
  {
    id: "7",
    title: "Swiss Life steigt in den Krypto-Markt ein",
    subtitle: "Erstmals Krypto-Anlageprodukte für institutionelle Kunden ab Juni 2026",
    slug: "swiss-life-krypto-markt",
    excerpt: "Der Versicherungskonzern Swiss Life bietet ab Juni 2026 erstmals Krypto-Anlageprodukte für institutionelle Kunden an.",
    content: "Der Versicherungskonzern Swiss Life bietet ab Juni 2026 erstmals Krypto-Anlageprodukte für institutionelle Kunden an. Bitcoin und Ethereum werden als Basis-Anlagen angeboten.\n\nDie FINMA hat die Produkte bereits genehmigt. Swiss Life ist damit der erste Schweizer Versicherer, der Krypto-Anlagen in sein Portfolio aufnimmt.\n\n\"Wir sehen Krypto als eine neue Anlageklasse mit Potenzial\", sagte Swiss-Life-CEO Patrick Frost. \"Unsere Kunden verlangen nach diversifizierten Anlagemöglichkeiten.\"\n\nDie Produkte sind zunächst nur für institutionelle Kunden verfügbar. Privatanleger sollen ab 2027 Zugang erhalten. Die Mindestanlage beträgt 100.000 Franken.",
    category: "Finanzen",
    categorySlug: "finanzen",
    subcategory: "Anlagen",
    author: "Claudia Brunner",
    authorSlug: "claudia-brunner",
    authorRole: "Kolumnistin",
    authorBio: "Claudia Brunner schreibt seit 2018 die wöchentliche Kolumne \"Brunners Blick\".",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20columnist%20portrait%20elegant%20woman%20in%20her%2050s%20wearing%20statement%20jewelry%20confident%20expressive%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=106&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Digital%20cryptocurrency%20concept%20Bitcoin%20Ethereum%20coins%20with%20Swiss%20flag%20elements%20modern%20fintech%20visualization%20clean%20professional%20photography%20dark%20background%20dramatic%20lighting&width=1200&height=675&seq=7&orientation=landscape",
    publishedAt: "2026-04-24T08:00:00Z",
    updatedAt: "2026-04-24T10:00:00Z",
    readTime: "4 Min.",
    views: 7650,
    tags: ["Krypto", "Swiss Life", "Anlage", "Bitcoin"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "FINMA", url: "https://www.finma.ch" },
    ],
    internalLinks: [
      { title: "Krypto in der Schweiz", slug: "krypto-schweiz" },
    ],
    externalLinks: [
      { title: "Swiss Life", url: "https://www.swisslife.ch" },
    ],
  },
  {
    id: "8",
    title: "Neue Studie: Homeoffice erhöht Produktivität um 15 Prozent",
    subtitle: "ETH-Studie mit 5.000 Beschäftigten über zwei Jahre bestätigt Effizienzgewinne",
    slug: "homeoffice-produktivitaet-studie",
    excerpt: "Eine ETH-Studie zeigt, dass Schweizer Arbeitnehmer im Homeoffice durchschnittlich 15 Prozent produktiver sind als im Büro.",
    content: "Eine ETH-Studie zeigt, dass Schweizer Arbeitnehmer im Homeoffice durchschnittlich 15 Prozent produktiver sind als im Büro. Die Untersuchung umfasste 5.000 Beschäftigte über zwei Jahre.\n\nArbeitgeberverbände zeigen sich skeptisch. Sie befürchten einen Verlust der Unternehmenskultur und Schwierigkeiten bei der Teamarbeit.\n\n\"Die Daten sind eindeutig\", sagt Studienleiter Prof. Dr. Thomas D. Zweifel. \"Homeoffice führt zu höherer Zufriedenheit und Produktivität.\"\n\nDie Studie zeigt zudem, dass Homeoffice die Work-Life-Balance verbessert und die Fluktuation reduziert. Allerdings gibt es auch Herausforderungen: Die soziale Isolation nimmt zu, und die Grenzen zwischen Arbeit und Privatleben verschwimmen.",
    category: "Arbeit & Leben",
    categorySlug: "arbeit-leben",
    subcategory: "Arbeitsmarkt",
    author: "Dr. Michael Lang",
    authorSlug: "michael-lang",
    authorRole: "Kolumnist",
    authorBio: "Dr. Michael Lang ist Wirtschaftswissenschaftler und Kolumnist.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20economist%20columnist%20portrait%20man%20in%20his%2040s%20wearing%20turtleneck%20intellectual%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=107&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20Swiss%20home%20office%20setup%20laptop%20on%20wooden%20desk%20large%20window%20with%20mountain%20view%20minimalist%20interior%20natural%20light%20professional%20photography%20warm%20tones&width=1200&height=675&seq=8&orientation=landscape",
    publishedAt: "2026-04-23T13:00:00Z",
    updatedAt: "2026-04-23T15:00:00Z",
    readTime: "5 Min.",
    views: 10230,
    tags: ["Homeoffice", "Arbeit", "ETH", "Produktivität"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "ETH Zürich Arbeitsmarktstudie", url: "https://www.ethz.ch" },
    ],
    internalLinks: [
      { title: "Arbeiten in der Schweiz", slug: "arbeiten-schweiz" },
    ],
    externalLinks: [
      { title: "Swiss Employers Association", url: "https://www.arbeitgeber.ch" },
    ],
  },
  {
    id: "9",
    title: "Roche meldet Durchbruch bei Alzheimer-Forschung",
    subtitle: "Phase-III-Studien zeigen 35 Prozent Verlangsamung der kognitiven Abnahme",
    slug: "roche-alzheimer-durchbruch",
    excerpt: "Der Basler Pharmariese Roche hat in Phase-III-Studien vielversprechende Ergebnisse bei einem neuen Alzheimer-Medikament erzielt.",
    content: "Der Basler Pharmariese Roche hat in Phase-III-Studien vielversprechende Ergebnisse bei einem neuen Alzheimer-Medikament erzielt. Die kognitive Abnahme konnte um 35 Prozent verlangsamt werden.\n\nDie Zulassung wird für 2027 erwartet. Experten sprechen von einem potenziellen Wendepunkt in der Alzheimer-Therapie.\n\n\"Dies ist ein historischer Moment\", sagt Roche-CEO Thomas Schinecker. \"Wir haben ein Medikament entwickelt, das den Verlauf der Krankheit signifikant verlangsamen kann.\"\n\nDas Medikament, ein monoklonaler Antikörper, zielt auf das Amyloid-Beta-Protein ab. Die Studie umfasste 1.800 Patienten in 30 Ländern. Die Nebenwirkungen waren moderat.",
    category: "Versicherung & Gesundheit",
    categorySlug: "versicherung-gesundheit",
    subcategory: "Medizin",
    author: "Dr. Anna Fischer",
    authorSlug: "anna-fischer",
    authorRole: "Gesundheits-Redakteurin",
    authorBio: "Dr. Anna Fischer ist promovierte Medizinerin und leitende Gesundheits-Redakteurin.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20journalist%20portrait%20woman%20in%20her%2040s%20wearing%20elegant%20blouse%20confident%20warm%20smile%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=102&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Roche%20pharmaceutical%20laboratory%20Basel%20Switzerland%20scientists%20working%20with%20microscopes%20modern%20research%20facility%20clean%20white%20interior%20professional%20photography%20dramatic%20lighting&width=1200&height=675&seq=9&orientation=landscape",
    publishedAt: "2026-04-23T07:45:00Z",
    updatedAt: "2026-04-23T09:00:00Z",
    readTime: "6 Min.",
    views: 18900,
    tags: ["Roche", "Alzheimer", "Medizin", "Pharma"],
    status: "published",
    isFeatured: false,
    isBreaking: true,
    isTopNews: true,
    showOnHomepageSlider: false,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Roche Pressemitteilung", url: "https://www.roche.com" },
    ],
    internalLinks: [
      { title: "Die Schweizer Pharma-Industrie", slug: "schweizer-pharma" },
    ],
    externalLinks: [
      { title: "Roche", url: "https://www.roche.ch" },
      { title: "Alzheimer Forschung", url: "https://www.alz.org" },
    ],
  },
  {
    id: "10",
    title: "Schweizer Franken erreicht 5-Jahres-Hoch gegenüber dem Euro",
    subtitle: "Ein Euro kostet nur noch 0,92 Franken – SNB dürfte intervenieren",
    slug: "schweizer-franken-5-jahres-hoch",
    excerpt: "Der Schweizer Franken hat am Dienstag ein neues 5-Jahres-Hoch gegenüber dem Euro erreicht. Ein Euro kostet nur noch 0,92 Franken.",
    content: "Der Schweizer Franken hat am Dienstag ein neues 5-Jahres-Hoch gegenüber dem Euro erreicht. Ein Euro kostet nur noch 0,92 Franken.\n\nDie SNB dürfte intervenieren, um den Franken zu schwächen. Exporteure fürchten um ihre Wettbewerbsfähigkeit. Touristen aus der Eurozone werden von der Schweiz abgeschreckt.\n\n\"Der starke Franken ist ein Dauerthema\", sagt SNB-Präsident Martin Schlegel. \"Wir beobachten die Lage genau und werden bei Bedarf handeln.\"\n\nDie Exportindustrie leidet besonders. Maschinenbau, Pharma und Uhrenindustrie melden sinkende Margen. Die Tourismusbranche fürchtet einen Rückgang der Gäste aus der Eurozone.",
    category: "Finanzen",
    categorySlug: "finanzen",
    subcategory: "Währungen",
    author: "Hans Meier",
    authorSlug: "hans-meier",
    authorRole: "Wirtschafts-Redakteur",
    authorBio: "Hans Meier berichtet über Märkte, Währungen und die Schweizer Wirtschaft.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20business%20editor%20portrait%20man%20in%20his%2050s%20wearing%20dark%20sweater%20serious%20professional%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=110&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20franc%20banknotes%20and%20euro%20coins%20currency%20exchange%20concept%20financial%20markets%20professional%20photography%20clean%20background%20warm%20tones%20elegant%20composition&width=1200&height=675&seq=10&orientation=landscape",
    publishedAt: "2026-04-22T15:30:00Z",
    updatedAt: "2026-04-22T17:00:00Z",
    readTime: "3 Min.",
    views: 14560,
    tags: ["Franken", "Euro", "Wechselkurs", "SNB"],
    status: "published",
    isFeatured: false,
    isBreaking: true,
    isTopNews: true,
    showOnHomepageSlider: false,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "SNB Wechselkursdaten", url: "https://www.snb.ch" },
    ],
    internalLinks: [
      { title: "Die SNB und der Franken", slug: "snb-franken" },
    ],
    externalLinks: [
      { title: "SNB Schweiz", url: "https://www.snb.ch" },
    ],
  },
  {
    id: "11",
    title: "ChatGPT für Behörden: Kanton Zürich testet KI-Assistenten",
    subtitle: "KI-gestützter Bürgerservice soll Anfragen automatisch beantworten",
    slug: "kanton-zuerich-ki-assistent",
    excerpt: "Der Kanton Zürich pilotiert einen KI-gestützten Bürgerservice, der Anfragen automatisch beantworten und Formulare ausfüllen soll.",
    content: "Der Kanton Zürich pilotiert einen KI-gestützten Bürgerservice, der Anfragen automatisch beantworten und Formulare ausfüllen soll. Die Testphase läuft bis September 2026.\n\nDatenschützer beobachten das Projekt kritisch. Der Kanton betont, dass alle Daten in der Schweiz verarbeitet werden.\n\n\"Wir wollen den Bürgerservice effizienter machen\", sagt Kantonsrat Ernst Stocker. \"Die KI soll einfache Anfragen bearbeiten, damit unsere Mitarbeiter sich um komplexe Fälle kümmern können.\"\n\nDas System basiert auf einem angepassten GPT-Modell. Es wurde mit 50.000 historischen Anfragen trainiert. Die Genauigkeit liegt bei 92 Prozent.",
    category: "Digital & KI",
    categorySlug: "digital-ki",
    subcategory: "Digitalisierung",
    author: "Sarah Müller",
    authorSlug: "sarah-mueller",
    authorRole: "Tech-Redakteurin",
    authorBio: "Sarah Müller berichtet über Technologie und KI aus der Schweiz.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20journalist%20portrait%20woman%20in%20her%2030s%20wearing%20modern%20casual%20outfit%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=104&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20Swiss%20government%20office%20digital%20transformation%20computer%20screens%20showing%20AI%20interface%20clean%20minimalist%20workspace%20professional%20photography&width=1200&height=675&seq=11&orientation=landscape",
    publishedAt: "2026-04-22T10:15:00Z",
    updatedAt: "2026-04-22T12:00:00Z",
    readTime: "5 Min.",
    views: 6780,
    tags: ["KI", "Zürich", "Digitalisierung", "ChatGPT"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Kanton Zürich", url: "https://www.zh.ch" },
    ],
    internalLinks: [
      { title: "KI in der Verwaltung", slug: "ki-verwaltung" },
    ],
    externalLinks: [
      { title: "OpenAI", url: "https://www.openai.com" },
    ],
  },
  {
    id: "12",
    title: "Bundesgericht: Neue Regeln für Whistleblower in der Schweiz",
    subtitle: "Anonyme Hinweise müssen ernst genommen werden – Grundsatzentscheid",
    slug: "bundesgericht-whistleblower-regeln",
    excerpt: "Das Bundesgericht hat in einem Grundsatzentscheid den Schutz von Whistleblowern in der Schweiz gestärkt. Anonyme Hinweise müssen ernst genommen werden.",
    content: "Das Bundesgericht hat in einem Grundsatzentscheid den Schutz von Whistleblowern in der Schweiz gestärkt. Anonyme Hinweise müssen ernst genommen werden.\n\nDer Fall betraf einen ehemaligen Mitarbeiter einer Grossbank. Das Urteil könnte weitreichende Folgen für die Schweizer Unternehmenslandschaft haben.\n\n\"Dies ist ein Meilenstein für den Whistleblower-Schutz\", sagt Rechtsanwalt Dr. Martin Bösch. \"Die Schweiz holt damit international auf.\"\n\nDas Urteil verpflichtet Arbeitgeber, anonyme Hinweise ernst zu nehmen und zu prüfen. Retaliations-Massnahmen gegen Whistleblower sind nun explizit verboten. Die Entscheidung könnte die geplante Whistleblower-Gesetzgebung beeinflussen.",
    category: "Schweiz",
    categorySlug: "schweiz",
    subcategory: "Recht",
    author: "Ruth Steiner",
    authorSlug: "ruth-steiner",
    authorRole: "Rechts-Expertin",
    authorBio: "Ruth Steiner ist promovierte Juristin und berichtet über Rechtsprechung.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20lawyer%20portrait%20woman%20in%20her%2050s%20wearing%20elegant%20dark%20suit%20composed%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=109&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20Federal%20Supreme%20Court%20building%20Lausanne%20grand%20classical%20architecture%20columns%20professional%20photography%20dramatic%20sky%20documentary%20style%20wide%20angle&width=1200&height=675&seq=12&orientation=landscape",
    publishedAt: "2026-04-21T09:00:00Z",
    updatedAt: "2026-04-21T11:00:00Z",
    readTime: "6 Min.",
    views: 8900,
    tags: ["Whistleblower", "Recht", "Bundesgericht"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Bundesgericht", url: "https://www.bger.ch" },
    ],
    internalLinks: [
      { title: "Rechtsprechung in der Schweiz", slug: "rechtsprechung-schweiz" },
    ],
    externalLinks: [
      { title: "Transparency International", url: "https://www.transparency.ch" },
    ],
  },
  {
    id: "13",
    title: "Migros und Coop: Die besten Angebote dieser Woche",
    subtitle: "Preisvergleich zeigt, wo Sie am meisten sparen können",
    slug: "migros-coop-angebote-woche",
    excerpt: "Wir haben die aktuellen Angebote der beiden grössten Schweizer Detailhändler verglichen. Hier sind die besten Deals.",
    content: "Wir haben die aktuellen Angebote der beiden grössten Schweizer Detailhändler verglichen. Hier sind die besten Deals.\n\nDie Migros bietet diese Woche besonders günstige Bio-Produkte an. Der Coop punktet mit Aktionen im Elektronik-Bereich. Unser Preisvergleich zeigt, wo Sie am meisten sparen.\n\nTop-Deals dieser Woche:\n- Migros: Bio-Hähnchenbrust 500g für 9.90 statt 14.90\n- Coop: Samsung 55\" 4K TV für 499 statt 699\n- Migros: Nespresso-Maschine für 89 statt 129\n- Coop: 20% auf alle Möbel\n\nDie Angebote gelten bis Sonntag, 2. Mai 2026.",
    category: "Deals & Angebote",
    categorySlug: "deals-angebote",
    subcategory: "Supermärkte",
    author: "Lisa Huber",
    authorSlug: "lisa-huber",
    authorRole: "Redakteurin",
    authorBio: "Lisa Huber deckt Technologie- und Innovationsgeschichten auf.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20reporter%20portrait%20woman%20in%20her%2030s%20wearing%20smart%20casual%20friendly%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=108&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20supermarket%20interior%20modern%20grocery%20store%20clean%20aisles%20fresh%20products%20professional%20photography%20bright%20lighting%20wide%20angle&width=1200&height=675&seq=13&orientation=landscape",
    publishedAt: "2026-04-21T07:00:00Z",
    updatedAt: "2026-04-21T09:00:00Z",
    readTime: "4 Min.",
    views: 23400,
    tags: ["Migros", "Coop", "Angebote", "Shopping"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Migros Angebote", url: "https://www.migros.ch" },
      { title: "Coop Angebote", url: "https://www.coop.ch" },
    ],
    internalLinks: [
      { title: "Die besten Deals", slug: "beste-deals" },
    ],
    externalLinks: [
      { title: "Migros", url: "https://www.migros.ch" },
      { title: "Coop", url: "https://www.coop.ch" },
    ],
  },
  {
    id: "14",
    title: "Die Schweiz braucht endlich eine klare KI-Strategie",
    subtitle: "Während andere Länder bereits umfassende KI-Strategien verabschiedet haben, zögert die Schweiz",
    slug: "schweiz-ki-strategie-meinung",
    excerpt: "Während andere Länder bereits umfassende KI-Strategien verabschiedet haben, zögert die Schweiz. Das ist ein strategischer Fehler.",
    content: "Während andere Länder bereits umfassende KI-Strategien verabschiedet haben, zögert die Schweiz. Das ist ein strategischer Fehler.\n\nDie EU hat ihre KI-Verordnung, die USA investiert Milliarden, China fördert KI massiv. Die Schweiz riskiert, im globalen Wettbewerb zurückzufallen. Wir brauchen eine nationale KI-Agentur und gezielte Förderung.\n\n\"Die Schweiz hat exzellente Forschung, aber keine Strategie\", schreibt Claudia Brunner. \"Wir müssen KI als nationale Priorität behandeln.\"\n\nDie Schweiz braucht eine KI-Strategie, die Forschung, Bildung, Wirtschaft und Regulierung verbindet. Ohne klare Richtung verlieren wir Talente an andere Länder.",
    category: "Meinung",
    categorySlug: "meinung",
    subcategory: "Kommentar",
    author: "Claudia Brunner",
    authorSlug: "claudia-brunner",
    authorRole: "Kolumnistin",
    authorBio: "Claudia Brunner schreibt seit 2018 die wöchentliche Kolumne \"Brunners Blick\".",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20columnist%20portrait%20elegant%20woman%20in%20her%2050s%20wearing%20statement%20jewelry%20confident%20expressive%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=106&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Artificial%20intelligence%20concept%20Swiss%20flag%20combined%20with%20neural%20network%20visualization%20futuristic%20technology%20abstract%20professional%20photography%20dark%20background&width=1200&height=675&seq=14&orientation=landscape",
    publishedAt: "2026-04-20T06:00:00Z",
    updatedAt: "2026-04-20T08:00:00Z",
    readTime: "6 Min.",
    views: 5670,
    tags: ["KI", "Meinung", "Strategie", "Innovation"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "EU KI-Verordnung", url: "https://digital-strategy.ec.europa.eu" },
    ],
    internalLinks: [
      { title: "Meinungsbeiträge", slug: "meinung" },
    ],
    externalLinks: [
      { title: "Innosuisse", url: "https://www.innosuisse.ch" },
    ],
  },
  {
    id: "15",
    title: "Warum die Schweizer Wirtschaft trotz allem resilient bleibt",
    subtitle: "Trotz globaler Unsicherheit, starkem Franken und steigenden Kosten zeigt die Schweizer Wirtschaft bemerkenswerte Stärke",
    slug: "schweizer-wirtschaft-resilienz-kolumne",
    excerpt: "Trotz globaler Unsicherheit, starkem Franken und steigenden Kosten zeigt die Schweizer Wirtschaft bemerkenswerte Stärke. Die Gründe liegen tief verwurzelt.",
    content: "Trotz globaler Unsicherheit, starkem Franken und steigenden Kosten zeigt die Schweizer Wirtschaft bemerkenswerte Stärke. Die Gründe liegen tief verwurzelt.\n\nDie Dualität von Innovation und Tradition, die hohe Bildungsqualität und die politische Stabilität schaffen ein einzigartiges Ökosystem. Doch wir dürfen nicht selbstzufrieden werden.\n\n\"Die Schweiz ist ein Wirtschaftswunder\", schreibt Dr. Michael Lang. \"Aber Wunder brauchen ständige Erneuerung.\"\n\nDie Schweiz muss in Bildung, Innovation und Infrastruktur investieren. Die demografische Herausforderung erfordert zudem eine moderne Einwanderungspolitik.",
    category: "Kolumnen",
    categorySlug: "kolumnen",
    subcategory: "Wirtschaft",
    author: "Dr. Michael Lang",
    authorSlug: "michael-lang",
    authorRole: "Kolumnist",
    authorBio: "Dr. Michael Lang ist Wirtschaftswissenschaftler und Kolumnist.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20economist%20columnist%20portrait%20man%20in%20his%2040s%20wearing%20turtleneck%20intellectual%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=107&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20economic%20resilience%20concept%20modern%20Zurich%20financial%20district%20with%20Alps%20in%20background%20professional%20photography%20golden%20hour%20dramatic%20sky%20wide%20angle&width=1200&height=675&seq=15&orientation=landscape",
    publishedAt: "2026-04-19T06:00:00Z",
    updatedAt: "2026-04-19T08:00:00Z",
    readTime: "7 Min.",
    views: 4320,
    tags: ["Wirtschaft", "Kolumne", "Resilienz"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "SECO Wirtschaftsbericht", url: "https://www.seco.admin.ch" },
    ],
    internalLinks: [
      { title: "Kolumnen", slug: "kolumnen" },
    ],
    externalLinks: [
      { title: "State Secretariat for Economic Affairs", url: "https://www.seco.admin.ch" },
    ],
  },
  {
    id: "16",
    title: "Neue Zugverbindung Zürich-Mailand in 2,5 Stunden",
    subtitle: "SBB plant Hochgeschwindigkeitsverbindung – Investitionen von 2,4 Milliarden Franken",
    slug: "zugverbindung-zuerich-mailand-2026",
    excerpt: "Die SBB plant eine neue Hochgeschwindigkeitsverbindung zwischen Zürich und Mailand. Die Fahrzeit soll auf 2,5 Stunden reduziert werden.",
    content: "Die SBB plant eine neue Hochgeschwindigkeitsverbindung zwischen Zürich und Mailand. Die Fahrzeit soll auf 2,5 Stunden reduziert werden.\n\nDer Gotthard-Basistunnel wird für höhere Geschwindigkeiten ausgebaut. Die Investitionen belaufen sich auf 2,4 Milliarden Franken. Der Start ist für 2028 geplant.\n\n\"Dies ist ein Meilenstein für die Schweizer Bahn\", sagt SBB-CEO Vincent Ducrot. \"Wir verbinden die Schweiz noch enger mit Europa.\"\n\nDie neue Verbindung wird die Reisezeit um 45 Minuten verkürzen. Die Züge sollen mit bis zu 250 km/h fahren. Die Kapazität wird um 30 Prozent erhöht.",
    category: "Schweiz",
    categorySlug: "schweiz",
    subcategory: "Verkehr",
    author: "Markus Weber",
    authorSlug: "markus-weber",
    authorRole: "Chefredakteur",
    authorBio: "Markus Weber ist Chefredakteur des Helvetik Journal.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20journalist%20portrait%20middle%20aged%20man%20wearing%20dark%20blazer%20white%20shirt%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=101&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20Swiss%20high%20speed%20train%20passing%20through%20Alpine%20landscape%20sleek%20design%20professional%20photography%20dramatic%20mountain%20scenery%20wide%20angle&width=1200&height=675&seq=16&orientation=landscape",
    publishedAt: "2026-04-18T11:00:00Z",
    updatedAt: "2026-04-18T13:00:00Z",
    readTime: "4 Min.",
    views: 11200,
    tags: ["SBB", "Zug", "Verkehr", "Mailand"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "SBB", url: "https://www.sbb.ch" },
    ],
    internalLinks: [
      { title: "Verkehr in der Schweiz", slug: "verkehr-schweiz" },
    ],
    externalLinks: [
      { title: "SBB", url: "https://www.sbb.ch" },
      { title: "Trenitalia", url: "https://www.trenitalia.com" },
    ],
  },
  {
    id: "17",
    title: "Apple eröffnet zweites Entwicklungszentrum in Zürich",
    subtitle: "200 Millionen Franken Investition – Fokus auf KI-Chip-Design",
    slug: "apple-entwicklungszentrum-zuerich",
    excerpt: "Apple investiert 200 Millionen Franken in ein neues Entwicklungszentrum in Zürich. Der Fokus liegt auf KI-Chip-Design.",
    content: "Apple investiert 200 Millionen Franken in ein neues Entwicklungszentrum in Zürich. Der Fokus liegt auf KI-Chip-Design.\n\nBis 2027 sollen 150 neue Ingenieure eingestellt werden. Das Zentrum wird Apples grösster Chip-Design-Standort ausserhalb der USA.\n\n\"Zürich ist ein wichtiger Standort für uns\", sagte Apple-CEO Tim Cook bei der Ankündigung. \"Die Schweiz bietet exzellente Talente in Chip-Design und KI.\"\n\nDas neue Zentrum wird in der Nähe des bestehenden Apple-Standorts am Europaallee-Quartier eingerichtet. Die ETH Zürich ist als Forschungspartner involviert.",
    category: "Technologie",
    categorySlug: "technologie",
    subcategory: "Hardware",
    author: "Sarah Müller",
    authorSlug: "sarah-mueller",
    authorRole: "Tech-Redakteurin",
    authorBio: "Sarah Müller berichtet über Technologie und KI aus der Schweiz.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20journalist%20portrait%20woman%20in%20her%2030s%20wearing%20modern%20casual%20outfit%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=104&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Apple%20technology%20campus%20modern%20glass%20building%20Zurich%20Switzerland%20contemporary%20architecture%20professional%20photography%20daylight%20wide%20angle&width=1200&height=675&seq=17&orientation=landscape",
    publishedAt: "2026-04-17T09:30:00Z",
    updatedAt: "2026-04-17T11:00:00Z",
    readTime: "4 Min.",
    views: 8760,
    tags: ["Apple", "Zürich", "Chips", "KI"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Apple Newsroom", url: "https://www.apple.com/newsroom" },
    ],
    internalLinks: [
      { title: "Tech-Standort Zürich", slug: "tech-zuerich" },
    ],
    externalLinks: [
      { title: "Apple Schweiz", url: "https://www.apple.ch" },
    ],
  },
  {
    id: "18",
    title: "BAG warnt vor neuer Grippewelle im Mai",
    subtitle: "Besonders gefährdete Gruppen sollten sich impfen lassen",
    slug: "bag-grippewelle-mai-2026",
    excerpt: "Das Bundesamt für Gesundheit warnt vor einer neuen Grippewelle im Mai. Besonders gefährdete Gruppen sollten sich impfen lassen.",
    content: "Das Bundesamt für Gesundheit warnt vor einer neuen Grippewelle im Mai. Besonders gefährdete Gruppen sollten sich impfen lassen.\n\nDie Impfstoffe für die kommende Saison sind bereits verfügbar. Apotheken und Hausärzte bieten Impfungen an. Die Krankenkassen übernehmen die Kosten für Risikogruppen.\n\n\"Die Grippewelle könnte stärker ausfallen als erwartet\", warnt BAG-Direktorin Anne Lévy. \"Wir empfehlen allen Risikogruppen eine Impfung.\"\n\nDie Impfung ist für Personen über 65, Schwangere, chronisch Kranke und Gesundheitspersonal empfohlen. Die Impfung schützt zu 60-80 Prozent vor einer schweren Erkrankung.",
    category: "Versicherung & Gesundheit",
    categorySlug: "versicherung-gesundheit",
    subcategory: "Impfung",
    author: "Dr. Anna Fischer",
    authorSlug: "anna-fischer",
    authorRole: "Gesundheits-Redakteurin",
    authorBio: "Dr. Anna Fischer ist promovierte Medizinerin und leitende Gesundheits-Redakteurin.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20journalist%20portrait%20woman%20in%20her%2040s%20wearing%20elegant%20blouse%20confident%20warm%20smile%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=102&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20healthcare%20medical%20concept%20stethoscope%20and%20vaccine%20vials%20clean%20white%20background%20professional%20photography%20soft%20lighting%20elegant%20composition&width=1200&height=675&seq=18&orientation=landscape",
    publishedAt: "2026-04-16T08:00:00Z",
    updatedAt: "2026-04-16T10:00:00Z",
    readTime: "3 Min.",
    views: 15600,
    tags: ["Grippe", "BAG", "Impfung", "Gesundheit"],
    status: "published",
    isFeatured: false,
    isBreaking: true,
    isTopNews: true,
    showOnHomepageSlider: false,
    showInTopNewsColumn: true,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "BAG", url: "https://www.bag.admin.ch" },
    ],
    internalLinks: [
      { title: "Gesundheit in der Schweiz", slug: "gesundheit-schweiz" },
    ],
    externalLinks: [
      { title: "BAG Schweiz", url: "https://www.bag.admin.ch" },
    ],
  },
  {
    id: "19",
    title: "Die Zukunft der Schweizer Arbeit: Was 2030 erwartet",
    subtitle: "KI, Demografie und Globalisierung treiben fundamentale Veränderungen am Arbeitsmarkt",
    slug: "zukunft-schweizer-arbeit-2030",
    excerpt: "Eine neue Studie prognostiziert fundamentale Veränderungen am Schweizer Arbeitsmarkt bis 2030. KI, Demografie und Globalisierung treiben den Wandel.",
    content: "Eine neue Studie prognostiziert fundamentale Veränderungen am Schweizer Arbeitsmarkt bis 2030. KI, Demografie und Globalisierung treiben den Wandel.\n\nBis 2030 könnten 400.000 Arbeitsplätze durch Automatisierung verloren gehen. Gleichzeitig entstehen 300.000 neue Stellen in Tech und Gesundheit. Die Herausforderung liegt in der Qualifizierung.\n\n\"Die Schweiz muss sich auf den Wandel vorbereiten\", schreibt Dr. Michael Lang. \"Wir brauchen lebenslanges Lernen und eine moderne Berufsbildung.\"\n\nDie Studie empfiehlt Investitionen in Weiterbildung, eine flexiblere Arbeitsmarktpolitik und gezielte Förderung von MINT-Fächern.",
    category: "Arbeit & Leben",
    categorySlug: "arbeit-leben",
    subcategory: "Zukunft",
    author: "Dr. Michael Lang",
    authorSlug: "michael-lang",
    authorRole: "Kolumnist",
    authorBio: "Dr. Michael Lang ist Wirtschaftswissenschaftler und Kolumnist.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20economist%20columnist%20portrait%20man%20in%20his%2040s%20wearing%20turtleneck%20intellectual%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=107&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Future%20of%20work%20concept%20modern%20Swiss%20office%20with%20robots%20and%20humans%20collaborating%20futuristic%20professional%20photography%20clean%20lighting%20wide%20angle&width=1200&height=675&seq=19&orientation=landscape",
    publishedAt: "2026-04-15T10:00:00Z",
    updatedAt: "2026-04-15T12:00:00Z",
    readTime: "8 Min.",
    views: 7890,
    tags: ["Arbeit", "Zukunft", "KI", "Automatisierung"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "SECO Arbeitsmarktprognose", url: "https://www.seco.admin.ch" },
    ],
    internalLinks: [
      { title: "Arbeit & Leben", slug: "arbeit-leben" },
    ],
    externalLinks: [
      { title: "State Secretariat for Economic Affairs", url: "https://www.seco.admin.ch" },
    ],
  },
  {
    id: "20",
    title: "Luzern: Tourismus boomt trotz starkem Franken",
    subtitle: "Übernachtungen steigen um 12 Prozent – Asiatische Touristen als Wachstumsmotor",
    slug: "luzern-tourismus-boom-2026",
    excerpt: "Die Stadt Luzern verzeichnet trotz des starken Frankens einen Rekord-Tourismus. Übernachtungen steigen um 12 Prozent.",
    content: "Die Stadt Luzern verzeichnet trotz des starken Frankens einen Rekord-Tourismus. Übernachtungen steigen um 12 Prozent.\n\nDie neue Seilbahn auf den Pilatus und das erweiterte Kulturprogramm ziehen Besucher an. Asiatische Touristen machen einen wachsenden Anteil aus.\n\n\"Luzern ist attraktiver denn je\", sagt Tourismusdirektor Marcel Perren. \"Wir investieren in Erlebnisse, die unvergesslich bleiben.\"\n\nDie Stadt hat 50 Millionen Franken in Tourismus-Infrastruktur investiert. Neue Hotels, Restaurants und Kulturangebote sorgen für Vielfalt. Die Übernachtungszahlen übertrafen erstmals die Vorkrisenwerte.",
    category: "Schweiz",
    categorySlug: "schweiz",
    subcategory: "Tourismus",
    author: "Peter Schmid",
    authorSlug: "peter-schmid",
    authorRole: "Politik-Analyst",
    authorBio: "Peter Schmid ist einer der erfahrensten Politik-Journalisten der Schweiz.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20political%20analyst%20portrait%20senior%20man%20in%20his%2060s%20wearing%20glasses%20and%20blazer%20thoughtful%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=105&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Lucerne%20Switzerland%20cityscape%20with%20lake%20and%20mountains%20Chapel%20Bridge%20professional%20photography%20golden%20hour%20dramatic%20sky%20wide%20angle&width=1200&height=675&seq=20&orientation=landscape",
    publishedAt: "2026-04-14T14:00:00Z",
    updatedAt: "2026-04-14T16:00:00Z",
    readTime: "4 Min.",
    views: 9870,
    tags: ["Luzern", "Tourismus", "Wirtschaft"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Luzern Tourismus", url: "https://www.luzern.com" },
    ],
    internalLinks: [
      { title: "Schweiz entdecken", slug: "schweiz" },
    ],
    externalLinks: [
      { title: "Luzern Tourismus", url: "https://www.luzern.com" },
    ],
  },
  {
    id: "21",
    title: "Black Friday Schweiz 2026: Die besten Deals im Überblick",
    subtitle: "Von Elektronik bis Mode – wir haben die besten Angebote zusammengestellt",
    slug: "black-friday-schweiz-2026-deals",
    excerpt: "Wir haben die besten Black Friday Angebote der Schweizer Retailer zusammengestellt. Von Elektronik bis Mode – hier sparen Sie richtig.",
    content: "Wir haben die besten Black Friday Angebote der Schweizer Retailer zusammengestellt. Von Elektronik bis Mode – hier sparen Sie richtig.\n\nDigitec Galaxus bietet bis zu 50 Prozent Rabatt auf Elektronik. Die Migros hat Aktionen im gesamten Sortiment. Interdiscount punktet mit TV-Deals.\n\nTop-Deals:\n- Samsung 65\" 4K TV: 699 statt 1.299\n- Apple iPhone 16 Pro: 999 statt 1.199\n- Dyson Staubsauger: 399 statt 599\n- Nike Air Max: 89 statt 149\n\nDie Angebote gelten vom 27. bis 30. November 2026.",
    category: "Deals & Angebote",
    categorySlug: "deals-angebote",
    subcategory: "Black Friday",
    author: "Lisa Huber",
    authorSlug: "lisa-huber",
    authorRole: "Redakteurin",
    authorBio: "Lisa Huber deckt Technologie- und Innovationsgeschichten auf.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20reporter%20portrait%20woman%20in%20her%2030s%20wearing%20smart%20casual%20friendly%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=108&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Black%20Friday%20shopping%20concept%20Swiss%20retail%20store%20with%20sale%20signs%20modern%20interior%20professional%20photography%20bright%20lighting%20wide%20angle&width=1200&height=675&seq=21&orientation=landscape",
    publishedAt: "2026-04-13T07:00:00Z",
    updatedAt: "2026-04-13T09:00:00Z",
    readTime: "5 Min.",
    views: 34500,
    tags: ["Black Friday", "Deals", "Shopping", "Elektronik"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Digitec Galaxus", url: "https://www.digitec.ch" },
    ],
    internalLinks: [
      { title: "Deals & Angebote", slug: "deals-angebote" },
    ],
    externalLinks: [
      { title: "Digitec Galaxus", url: "https://www.digitec.ch" },
      { title: "Interdiscount", url: "https://www.interdiscount.ch" },
    ],
  },
  {
    id: "22",
    title: "Die EU will die Schweiz in den Energieverbund integrieren",
    subtitle: "Stromversorgung könnte sicherer werden – Kritiker warnen vor Energieautonomie-Verlust",
    slug: "eu-schweiz-energieverbund-integration",
    excerpt: "Die Europäische Union drängt auf eine stärkere Integration der Schweiz in den europäischen Energieverbund. Das könnte die Stromversorgung sicherer machen.",
    content: "Die Europäische Union drängt auf eine stärkere Integration der Schweiz in den europäischen Energieverbund. Das könnte die Stromversorgung sicherer machen.\n\nDie Schweiz würde damit enger an die EU gebunden. Kritiker warnen vor einem Verlust der Energieautonomie. Befürworter argumentieren mit mehr Versorgungssicherheit.\n\n\"Die Integration bietet Vorteile\", sagt Energieminister Albert Rösti. \"Aber wir dürfen unsere Unabhängigkeit nicht aufgeben.\"\n\nDie Verhandlungen laufen seit 2024. Ein Abkommen könnte 2027 unterzeichnet werden. Die Schweiz würde Zugang zum europäischen Strommarkt erhalten.",
    category: "Politik",
    categorySlug: "politik",
    subcategory: "Energiepolitik",
    author: "Markus Weber",
    authorSlug: "markus-weber",
    authorRole: "Chefredakteur",
    authorBio: "Markus Weber ist Chefredakteur des Helvetik Journal.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20journalist%20portrait%20middle%20aged%20man%20wearing%20dark%20blazer%20white%20shirt%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=101&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=European%20Union%20and%20Switzerland%20energy%20cooperation%20concept%20power%20lines%20connecting%20flags%20professional%20photography%20dramatic%20sky%20wide%20angle&width=1200&height=675&seq=22&orientation=landscape",
    publishedAt: "2026-04-12T09:00:00Z",
    updatedAt: "2026-04-12T11:00:00Z",
    readTime: "6 Min.",
    views: 7650,
    tags: ["EU", "Energie", "Politik", "Strom"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "EU Kommission Energie", url: "https://ec.europa.eu/energy" },
    ],
    internalLinks: [
      { title: "Schweizer Energiepolitik", slug: "energiepolitik" },
    ],
    externalLinks: [
      { title: "EU Kommission", url: "https://ec.europa.eu" },
      { title: "Swissgrid", url: "https://www.swissgrid.ch" },
    ],
  },
  {
    id: "23",
    title: "Novartis verkündet Milliarden-Investition in Basel",
    subtitle: "1,5 Milliarden Franken für Forschungszentrum – 500 neue Stellen",
    slug: "novartis-milliarden-investition-basel",
    excerpt: "Der Pharmariese Novartis investiert 1,5 Milliarden Franken in den Ausbau seines Basler Forschungszentrums. 500 neue Stellen entstehen.",
    content: "Der Pharmariese Novartis investiert 1,5 Milliarden Franken in den Ausbau seines Basler Forschungszentrums. 500 neue Stellen entstehen.\n\nDer Fokus liegt auf Krebsforschung und Gentherapie. Der Kanton Basel-Stadt begrüsst die Investition als wichtigen Wirtschaftsfaktor.\n\n\"Basel bleibt unser globales Forschungszentrum\", sagt Novartis-CEO Vas Narasimhan. \"Wir investieren in die Medizin der Zukunft.\"\n\nDas erweiterte Zentrum wird 2029 fertiggestellt. Es wird eines der grössten Pharma-Forschungszentren Europas. Die Investition sichert 3.000 bestehende Arbeitsplätze.",
    category: "Schweiz",
    categorySlug: "schweiz",
    subcategory: "Wirtschaft",
    author: "Dr. Anna Fischer",
    authorSlug: "anna-fischer",
    authorRole: "Gesundheits-Redakteurin",
    authorBio: "Dr. Anna Fischer ist promovierte Medizinerin und leitende Gesundheits-Redakteurin.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20journalist%20portrait%20woman%20in%20her%2040s%20wearing%20elegant%20blouse%20confident%20warm%20smile%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=102&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Novartis%20pharmaceutical%20headquarters%20Basel%20Switzerland%20modern%20research%20campus%20professional%20architecture%20photography%20dramatic%20sky%20wide%20angle&width=1200&height=675&seq=23&orientation=landscape",
    publishedAt: "2026-04-11T10:00:00Z",
    updatedAt: "2026-04-11T12:00:00Z",
    readTime: "4 Min.",
    views: 11200,
    tags: ["Novartis", "Basel", "Pharma", "Forschung"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Novartis", url: "https://www.novartis.com" },
    ],
    internalLinks: [
      { title: "Pharma-Standort Schweiz", slug: "pharma-schweiz" },
    ],
    externalLinks: [
      { title: "Novartis", url: "https://www.novartis.com" },
      { title: "Kanton Basel-Stadt", url: "https://www.bs.ch" },
    ],
  },
  {
    id: "24",
    title: "Die Schweizer Start-up-Szene: Ein Überblick 2026",
    subtitle: "Fintech, Healthtech und Cleantech dominieren – Rekordinvestitionen erreicht",
    slug: "schweizer-startup-szene-2026",
    excerpt: "Die Schweizer Start-up-Szene boomt. Wir haben die vielversprechendsten Unternehmen und Trends für 2026 analysiert.",
    content: "Die Schweizer Start-up-Szene boomt. Wir haben die vielversprechendsten Unternehmen und Trends für 2026 analysiert.\n\nFintech, Healthtech und Cleantech dominieren. Die ETH Zürich und EPFL Lausanne sind die wichtigsten Inkubatoren. Investitionen erreichen ein Rekordniveau.\n\n\"Die Schweiz ist ein Top-Standort für Startups\", sagt Venture-Capital-Experte Dr. Thomas D. Meyer. \"Wir sehen mehr Unicorns als je zuvor.\"\n\nDie Top-Startups 2026:\n- Climeworks (CO2-Entfernung)\n- MindMaze (Neurotechnologie)\n- GetYourGuide (Reiseplattform)\n- Scandit (Computer Vision)\n\nDie Investitionen beliefen sich 2025 auf 2,8 Milliarden Franken.",
    category: "Technologie",
    categorySlug: "technologie",
    subcategory: "Startups",
    author: "Sarah Müller",
    authorSlug: "sarah-mueller",
    authorRole: "Tech-Redakteurin",
    authorBio: "Sarah Müller berichtet über Technologie und KI aus der Schweiz.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20journalist%20portrait%20woman%20in%20her%2030s%20wearing%20modern%20casual%20outfit%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=104&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20startup%20ecosystem%20modern%20co-working%20space%20young%20entrepreneurs%20working%20laptops%20professional%20photography%20bright%20lighting%20wide%20angle&width=1200&height=675&seq=24&orientation=landscape",
    publishedAt: "2026-04-10T08:00:00Z",
    updatedAt: "2026-04-10T10:00:00Z",
    readTime: "6 Min.",
    views: 6780,
    tags: ["Startup", "Innovation", "Schweiz", "Venture Capital"],
    status: "published",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: true,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "Swiss Startup Monitor", url: "https://www.startupmonitor.ch" },
    ],
    internalLinks: [
      { title: "Innovation in der Schweiz", slug: "innovation-schweiz" },
    ],
    externalLinks: [
      { title: "Swiss Startup Association", url: "https://www.swissstartup.ch" },
      { title: "Venturelab", url: "https://www.venturelab.ch" },
    ],
  },
  {
    id: "25",
    title: "Entwurf: Neue Datenschutz-Verordnung für Schweizer Unternehmen",
    subtitle: "Angelehnt an EU-DSGVO – Verschärfte Regeln für Datenverarbeitung",
    slug: "neue-datenschutz-verordnung-schweiz-entwurf",
    excerpt: "Das Eidgenössische Justiz- und Polizeidepartement hat einen Entwurf für eine neue Datenschutz-Verordnung vorgelegt.",
    content: "Das Eidgenössische Justiz- und Polizeidepartement hat einen Entwurf für eine neue Datenschutz-Verordnung vorgelegt. Die Regeln sind an die EU-DSGVO angelehnt.\n\nUnternehmen müssen transparent über Datenverarbeitung informieren. Datenschutzbeauftragte werden verpflichtend. Verstösse können mit bis zu 500.000 Franken geahndet werden.\n\n\"Die Schweiz holt im Datenschutz auf\", sagt Datenschutz-Experte Dr. Martin Hirt. \"Das ist ein wichtiger Schritt für den digitalen Binnenmarkt.\"\n\nDie Vernehmlassung läuft bis August 2026. Die Verordnung könnte 2027 in Kraft treten.",
    category: "Schweiz",
    categorySlug: "schweiz",
    subcategory: "Datenschutz",
    author: "Ruth Steiner",
    authorSlug: "ruth-steiner",
    authorRole: "Rechts-Expertin",
    authorBio: "Ruth Steiner ist promovierte Juristin und berichtet über Rechtsprechung.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20female%20lawyer%20portrait%20woman%20in%20her%2050s%20wearing%20elegant%20dark%20suit%20composed%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=109&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Digital%20data%20protection%20concept%20shield%20with%20lock%20symbol%20clean%20professional%20photography%20blue%20gradient%20background%20modern%20technology&width=1200&height=675&seq=25&orientation=landscape",
    publishedAt: "2026-04-09T10:00:00Z",
    updatedAt: "2026-04-09T12:00:00Z",
    readTime: "5 Min.",
    views: 5430,
    tags: ["Datenschutz", "Recht", "DSGVO"],
    status: "draft",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: false,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "EJPD", url: "https://www.ejpd.admin.ch" },
    ],
    internalLinks: [
      { title: "Datenschutz in der Schweiz", slug: "datenschutz" },
    ],
    externalLinks: [
      { title: "EDÖB", url: "https://www.edoeb.admin.ch" },
    ],
  },
  {
    id: "26",
    title: "Interview: Wie die SNB den Franken im Blick behält",
    subtitle: "SNB-Vizepräsident Martin Schlegel im Gespräch über Geldpolitik und Wechselkurs",
    slug: "interview-snb-franken-geldpolitik",
    excerpt: "Im exklusiven Interview spricht SNB-Vizepräsident Martin Schlegel über die Herausforderungen der Geldpolitik und den starken Franken.",
    content: "Im exklusiven Interview spricht SNB-Vizepräsident Martin Schlegel über die Herausforderungen der Geldpolitik und den starken Franken.\n\n\"Der starke Franken ist eine Herausforderung für die Exportwirtschaft\", sagt Schlegel. \"Aber er schützt auch vor Importinflation.\"\n\nDie SNB hat den Leitzins im März um 25 Basispunkte gesenkt. Weitere Zinssenkungen sind möglich, falls die Inflation weiter sinkt.\n\n\"Wir bleiben wachsam\", betont Schlegel. \"Die globale Unsicherheit erfordert eine flexible Geldpolitik.\"",
    category: "Finanzen",
    categorySlug: "finanzen",
    subcategory: "Geldpolitik",
    author: "Thomas Keller",
    authorSlug: "thomas-keller",
    authorRole: "Finanz-Experte",
    authorBio: "Thomas Keller ist ehemaliger Banker und heute unabhängiger Finanzjournalist.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20finance%20expert%20portrait%20man%20in%20his%2050s%20wearing%20suit%20and%20tie%20serious%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=103&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Swiss%20National%20Bank%20building%20Bern%20modern%20architecture%20professional%20photography%20dramatic%20sky%20wide%20angle%20financial%20institution&width=1200&height=675&seq=26&orientation=landscape",
    publishedAt: "2026-04-08T14:00:00Z",
    updatedAt: "2026-04-08T16:00:00Z",
    readTime: "8 Min.",
    views: 3210,
    tags: ["SNB", "Franken", "Geldpolitik", "Interview"],
    status: "pending_review",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: false,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "SNB", url: "https://www.snb.ch" },
    ],
    internalLinks: [
      { title: "Geldpolitik", slug: "geldpolitik" },
    ],
    externalLinks: [
      { title: "SNB", url: "https://www.snb.ch" },
    ],
  },
  {
    id: "27",
    title: "Geplant: Neue Solar-Offensive für Schweizer Dächer",
    subtitle: "Bundesrat will Solaranlagen auf allen neuen Gebäuden verpflichtend machen",
    slug: "solar-offensive-schweizer-daecher-geplant",
    excerpt: "Der Bundesrat plant eine Solar-Offensive, die Solaranlagen auf allen neuen Gebäuden verpflichtend machen soll.",
    content: "Der Bundesrat plant eine Solar-Offensive, die Solaranlagen auf allen neuen Gebäuden verpflichtend machen soll. Bestehende Gebäude sollen bei Renovationen nachgerüstet werden.\n\nDie Massnahme ist Teil des Klimaschutz-Pakets. Sie soll die Schweizer Solarleistung bis 2030 verdreifachen.\n\n\"Jedes Dach muss ein Solardach werden können\", sagt Umweltminister Albert Rösti. \"Die Technologie ist reif, die Kosten sind gesunken.\"\n\nDie Bauwirtschaft zeigt sich skeptisch. Sie befürchtet höhere Baukosten und längere Planungszeiten. Die Vernehmlassung läuft bis Juni 2026.",
    category: "Politik",
    categorySlug: "politik",
    subcategory: "Energiepolitik",
    author: "Markus Weber",
    authorSlug: "markus-weber",
    authorRole: "Chefredakteur",
    authorBio: "Markus Weber ist Chefredakteur des Helvetik Journal.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20male%20journalist%20portrait%20middle%20aged%20man%20wearing%20dark%20blazer%20white%20shirt%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=101&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Solar%20panels%20on%20Swiss%20rooftop%20modern%20house%20with%20Alpine%20mountains%20in%20background%20clean%20energy%20concept%20professional%20photography%20bright%20daylight%20wide%20angle&width=1200&height=675&seq=27&orientation=landscape",
    publishedAt: "2026-05-01T08:00:00Z",
    updatedAt: "2026-04-07T10:00:00Z",
    readTime: "4 Min.",
    views: 0,
    tags: ["Solar", "Energie", "Klima", "Bundesrat"],
    status: "scheduled",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: false,
    commentsEnabled: true,
    adsEnabled: true,
    sources: [
      { title: "BFE", url: "https://www.bfe.admin.ch" },
    ],
    internalLinks: [
      { title: "Erneuerbare Energien", slug: "erneuerbare-energien" },
    ],
    externalLinks: [
      { title: "Swissolar", url: "https://www.swissolar.ch" },
    ],
  },
  {
    id: "28",
    title: "Rückblick: Die grössten Tech-Flops der Schweiz",
    subtitle: "Von Swissair bis Crypto Valley – gescheiterte Projekte und was wir daraus lernen",
    slug: "tech-flops-schweiz-rueckblick",
    excerpt: "Ein Rückblick auf die grössten technologischen Fehlschläge der Schweiz – und die Lehren, die wir daraus ziehen können.",
    content: "Ein Rückblick auf die grössten technologischen Fehlschläge der Schweiz – und die Lehren, die wir daraus ziehen können.\n\nVon Swissair bis Crypto Valley: Die Schweiz hat auch ihre tech-technischen Rückschläge erlebt. Doch aus jedem Flop lässt sich lernen.\n\n\"Fehler sind Teil des Innovationsprozesses\", sagt ETH-Professor Dr. Joël Mesot. \"Die Schweiz hat gelernt, Risiken besser zu managen.\"\n\nDie grössten Flops:\n- Swissair Grounding 2001\n- Crypto Valley Hype 2018\n- Swisscom TV-Plattform\n- PostAuto-Skandal\n\nDie Lehren: Transparenz, Regulierung und langfristige Planung sind entscheidend.",
    category: "Technologie",
    categorySlug: "technologie",
    subcategory: "Geschichte",
    author: "Sarah Müller",
    authorSlug: "sarah-mueller",
    authorRole: "Tech-Redakteurin",
    authorBio: "Sarah Müller berichtet über Technologie und KI aus der Schweiz.",
    authorImage: "https://readdy.ai/api/search-image?query=Professional%20young%20female%20tech%20journalist%20portrait%20woman%20in%20her%2030s%20wearing%20modern%20casual%20outfit%20confident%20expression%20neutral%20studio%20background%20soft%20lighting%20editorial%20photography&width=400&height=400&seq=104&orientation=squarish",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20technology%20failure%20concept%20broken%20circuit%20board%20with%20Swiss%20elements%20dark%20moody%20professional%20photography%20dramatic%20lighting&width=1200&height=675&seq=28&orientation=landscape",
    publishedAt: "2025-12-15T10:00:00Z",
    updatedAt: "2025-12-15T12:00:00Z",
    readTime: "7 Min.",
    views: 8900,
    tags: ["Tech", "Geschichte", "Schweiz", "Innovation"],
    status: "archived",
    isFeatured: false,
    isBreaking: false,
    isTopNews: false,
    showOnHomepageSlider: false,
    showInTopNewsColumn: false,
    showInCategoryFeatured: false,
    commentsEnabled: false,
    adsEnabled: true,
    sources: [
      { title: "ETH Innovation", url: "https://www.ethz.ch" },
    ],
    internalLinks: [
      { title: "Schweizer Tech-Geschichte", slug: "tech-geschichte" },
    ],
    externalLinks: [
      { title: "Swiss Innovation Park", url: "https://www.swissinnovationpark.ch" },
    ],
  },
];

export const getFeaturedArticles = (count: number = 5): Article[] => {
  return articles.filter((a) => a.isFeatured).slice(0, count);
};

export const getBreakingNews = (): Article[] => {
  return articles.filter((a) => a.isBreaking);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getLatestArticles = (count: number = 6): Article[] => {
  return [...articles]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, count);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByAuthor = (authorSlug: string): Article[] => {
  return articles.filter((a) => a.authorSlug === authorSlug);
};

export const getAuthorBySlug = (slug: string): Author | undefined => {
  return authors.find((a) => a.slug === slug);
};

export const getColumnists = (): Author[] => {
  return authors.filter((a) => a.author_type === "kolumnist");
};

export const getOpinionArticles = (): Article[] => {
  return articles.filter((a) => a.isOpinion || a.isColumn || a.categorySlug === "kolumnen" || a.categorySlug === "meinung");
};

export const searchArticles = (query: string): Article[] => {
  const q = query.toLowerCase();
  return articles.filter(
    (a) =>
      a.title.toLowerCase().includes(q) ||
      a.excerpt.toLowerCase().includes(q) ||
      a.content.toLowerCase().includes(q) ||
      a.tags.some((t) => t.toLowerCase().includes(q)) ||
      a.author.toLowerCase().includes(q) ||
      a.category.toLowerCase().includes(q)
  );
};

export const getArticlesByStatus = (status: Article["status"]): Article[] => {
  return articles.filter((a) => a.status === status);
};

export const getNextArticle = (currentId: string): Article | undefined => {
  const idx = articles.findIndex((a) => a.id === currentId);
  if (idx >= 0 && idx < articles.length - 1) {
    return articles[idx + 1];
  }
  return undefined;
};

export const getPreviousArticle = (currentId: string): Article | undefined => {
  const idx = articles.findIndex((a) => a.id === currentId);
  if (idx > 0) {
    return articles[idx - 1];
  }
  return undefined;
};

export interface SearchFilters {
  query?: string;
  category?: string;
  author?: string;
  dateFrom?: string;
  dateTo?: string;
  tags?: string[];
  status?: Article["status"];
  sortBy?: "relevance" | "newest" | "oldest" | "most_viewed" | "least_viewed";
}

export interface SearchResult {
  articles: Article[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
  filters: SearchFilters;
}

export function filterArticles(
  filters: SearchFilters,
  page = 1,
  perPage = 12
): SearchResult {
  let results = [...articles];

  // Keyword search with relevance scoring
  if (filters.query && filters.query.trim()) {
    const q = filters.query.toLowerCase().trim();
    const qWords = q.split(/\s+/).filter((w) => w.length > 1);

    results = results.map((a) => {
      let score = 0;
      const titleLower = a.title.toLowerCase();
      const excerptLower = a.excerpt.toLowerCase();
      const contentLower = a.content.toLowerCase();
      const tagsLower = a.tags.map((t) => t.toLowerCase());
      const authorLower = a.author.toLowerCase();
      const categoryLower = a.category.toLowerCase();

      // Exact title match = highest score
      if (titleLower === q) score += 100;
      else if (titleLower.includes(q)) score += 50;

      // Word matches in title
      qWords.forEach((word) => {
        if (titleLower.includes(word)) score += 20;
      });

      // Excerpt match
      if (excerptLower.includes(q)) score += 15;
      qWords.forEach((word) => {
        if (excerptLower.includes(word)) score += 8;
      });

      // Content match
      if (contentLower.includes(q)) score += 5;
      qWords.forEach((word) => {
        if (contentLower.includes(word)) score += 2;
      });

      // Tag match
      if (tagsLower.some((t) => t.includes(q))) score += 25;
      qWords.forEach((word) => {
        if (tagsLower.some((t) => t.includes(word))) score += 12;
      });

      // Author match
      if (authorLower.includes(q)) score += 15;

      // Category match
      if (categoryLower.includes(q)) score += 10;

      return { article: a, score };
    })
      .filter((r) => r.score > 0)
      .sort((a, b) => b.score - a.score)
      .map((r) => r.article);
  }

  // Category filter
  if (filters.category) {
    results = results.filter((a) => a.categorySlug === filters.category);
  }

  // Author filter
  if (filters.author) {
    results = results.filter((a) => a.authorSlug === filters.author);
  }

  // Date range filter
  if (filters.dateFrom) {
    const from = new Date(filters.dateFrom).getTime();
    results = results.filter((a) => new Date(a.publishedAt).getTime() >= from);
  }
  if (filters.dateTo) {
    const to = new Date(filters.dateTo).getTime();
    results = results.filter((a) => new Date(a.publishedAt).getTime() <= to);
  }

  // Tag filter
  if (filters.tags && filters.tags.length > 0) {
    results = results.filter((a) =>
      filters.tags!.some((tag) => a.tags.some((t) => t.toLowerCase() === tag.toLowerCase()))
    );
  }

  // Status filter (default to published only for frontend)
  if (filters.status) {
    results = results.filter((a) => a.status === filters.status);
  } else {
    results = results.filter((a) => a.status === "published");
  }

  // Sorting
  const sortBy = filters.sortBy || "relevance";
  if (sortBy === "newest") {
    results.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());
  } else if (sortBy === "oldest") {
    results.sort((a, b) => new Date(a.publishedAt).getTime() - new Date(b.publishedAt).getTime());
  } else if (sortBy === "most_viewed") {
    results.sort((a, b) => b.views - a.views);
  } else if (sortBy === "least_viewed") {
    results.sort((a, b) => a.views - b.views);
  }
  // relevance: already sorted by score above, or default to newest
  if (sortBy === "relevance" && !filters.query) {
    results.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());
  }

  const total = results.length;
  const totalPages = Math.ceil(total / perPage);
  const safePage = Math.max(1, Math.min(page, totalPages || 1));
  const start = (safePage - 1) * perPage;
  const paginated = results.slice(start, start + perPage);

  return {
    articles: paginated,
    total,
    page: safePage,
    perPage,
    totalPages,
    filters,
  };
}

export const allTags = Array.from(
  new Set(articles.flatMap((a) => a.tags))
).sort();

export const allCategories = Array.from(
  new Set(articles.map((a) => a.categorySlug))
).map((slug) => ({
  slug,
  name: articles.find((a) => a.categorySlug === slug)?.category || slug,
}));

export const allAuthors = authors.map((a) => ({
  slug: a.slug,
  name: a.name,
}));

export const categoryMeta: Record<string, { title: string; description: string; color: string }> = {
  wirtschaft: {
    title: "Wirtschaft",
    description: "Schweizer Wirtschaftsnachrichten, Unternehmensberichte und Marktanalysen.",
    color: "bg-teal-700",
  },
  "migration-integration": {
    title: "Migration & Integration",
    description: "Einwanderung, Asylpolitik, Integration und gesellschaftlicher Wandel in der Schweiz.",
    color: "bg-pink-700",
  },
  bildung: {
    title: "Bildung",
    description: "Bildungspolitik, Schulen, Universitäten und Forschung in der Schweiz.",
    color: "bg-cyan-700",
  },
  schweiz: {
    title: "Schweiz",
    description: "Aktuelle Nachrichten aus der Schweiz. Politik, Wirtschaft, Gesellschaft und Kultur im Überblick.",
    color: "bg-hj-red",
  },
  finanzen: {
    title: "Finanzen",
    description: "Börsennews, Aktienanalysen, Wirtschaftsberichte und Finanztipps für die Schweiz.",
    color: "bg-emerald-700",
  },
  "versicherung-gesundheit": {
    title: "Versicherung & Gesundheit",
    description: "News zu Krankenkassen, Prämien, Gesundheitspolitik und medizinischen Innovationen.",
    color: "bg-teal-700",
  },
  technologie: {
    title: "Technologie",
    description: "Die neuesten Entwicklungen in Technologie, Software und Digitalisierung.",
    color: "bg-sky-700",
  },
  "digital-ki": {
    title: "Digital & KI",
    description: "Künstliche Intelligenz, Machine Learning und digitale Transformation in der Schweiz.",
    color: "bg-indigo-700",
  },
  "arbeit-leben": {
    title: "Arbeit & Leben",
    description: "Arbeitsmarkt, Work-Life-Balance, Karriere und Lifestyle in der Schweiz.",
    color: "bg-amber-700",
  },
  politik: {
    title: "Politik",
    description: "Politische News aus Bern, Wahlen, Abstimmungen und Analysen aus der Schweiz.",
    color: "bg-slate-700",
  },
  "deals-angebote": {
    title: "Deals & Angebote",
    description: "Die besten Angebote, Deals und Spartipps für die Schweiz.",
    color: "bg-orange-700",
  },
  meinung: {
    title: "Meinung",
    description: "Kommentare, Analysen und Meinungsbeiträge zu aktuellen Themen.",
    color: "bg-hj-red",
  },
  kolumnen: {
    title: "Kolumnen",
    description: "Wöchentliche Kolumnen unserer erfahrenen Autoren.",
    color: "bg-hj-red",
  },
};
